import { GetSalaryChangeRequestDetailsResponse } from 'api/laborerPortalAPI/authContract'
import { CallAPIAction, Status } from 'api/types'
import {
  convertSalaryChangeRequestFromResponse,
  LaborerSalaryChangeRequest,
} from 'common/utils/convertResponse/convertLaborerAuthResponse'
import Actions from 'redux/actions'

type State = {
  request: LaborerSalaryChangeRequest | null
} & Status

const initialState: State = {
  request: null,
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.GET_LABORER_SALARY_CHANGE_REQUEST_DETAILS_ASYNC,
    Actions.GET_LABORER_SALARY_CHANGE_REQUEST_DETAILS_SUCCESS,
    Actions.GET_LABORER_SALARY_CHANGE_REQUEST_DETAILS_FAIL,
    GetSalaryChangeRequestDetailsResponse
  >,
): State => {
  switch (action.type) {
    case Actions.GET_LABORER_SALARY_CHANGE_REQUEST_DETAILS_ASYNC:
    case Actions.GET_LABORER_SALARY_CHANGE_REQUEST_DETAILS_FAIL:
      return {
        ...state,
        ...action.status,
      }

    case Actions.GET_LABORER_SALARY_CHANGE_REQUEST_DETAILS_SUCCESS:
      return {
        ...state,
        ...action.status,
        request: convertSalaryChangeRequestFromResponse(action.payload.data),
      }

    default:
      return state
  }
}
